/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

import { library } from '@fortawesome/fontawesome-svg-core';

// Brands
import { faAppStore as fabAppStore } from '@fortawesome/free-brands-svg-icons/faAppStore';
import { faGooglePlay as fabGooglePlay } from '@fortawesome/free-brands-svg-icons/faGooglePlay';
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest as fabPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faTumblr as fabTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faXTwitter as fabXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYelp as fabYelp } from '@fortawesome/free-brands-svg-icons/faYelp';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faBloggerB as fabBloggerB } from '@fortawesome/free-brands-svg-icons/faBloggerB';
import { faTiktok as fabTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faWeibo as fabWeibo } from '@fortawesome/free-brands-svg-icons/faWeibo';

// Regular
import { faAt as farAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faAward as farAward } from '@fortawesome/pro-regular-svg-icons/faAward';
import { faBadge as farBadge } from '@fortawesome/pro-regular-svg-icons/faBadge';
import { faBell as farBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faBook as farBook } from '@fortawesome/pro-regular-svg-icons/faBook';
import { faBookReader as farBookReader } from '@fortawesome/pro-regular-svg-icons/faBookReader';
import { faCalendar as farCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCalendarAlt as farCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faChartLineUp as farChartLineUp } from '@fortawesome/pro-regular-svg-icons/faChartLineUp';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faCircleDollar as farCircleDollar } from '@fortawesome/pro-regular-svg-icons/faCircleDollar';
import { faCircleExclamation as farCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation';
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faCopy as farCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { faDollarSign as farDollarSign } from '@fortawesome/pro-regular-svg-icons/faDollarSign';
import { faDownload as farDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faExclamationTriangle as farExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';
import { faCircleCheck as farCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faFileCertificate as farFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faFileXmark as farFileXmark } from '@fortawesome/pro-regular-svg-icons/faFileXmark';
import { faGraduationCap as farGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faHandWave as farHandWave } from '@fortawesome/pro-regular-svg-icons/faHandWave';
import { faHandshake as farHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faList as farList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faMegaphone as farMegaphone } from '@fortawesome/pro-regular-svg-icons/faMegaphone';
import { faMemoCircleCheck as farMemoCircleCheck } from '@fortawesome/pro-regular-svg-icons/faMemoCircleCheck';
import { faPrint as farPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faSearchPlus as farSearchPlus } from '@fortawesome/pro-regular-svg-icons/faSearchPlus';
import { faStroopwafel as farStroopwafel } from '@fortawesome/pro-regular-svg-icons/faStroopwafel';
import { faTriangleExclamation as farTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faTrophy as farTrophy } from '@fortawesome/pro-regular-svg-icons/faTrophy';
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';

// Light
import { faList as falList } from '@fortawesome/pro-light-svg-icons/faList';
import { faHome as falHome } from '@fortawesome/pro-light-svg-icons/faHome';
import { faMegaphone as falMegaphone } from '@fortawesome/pro-light-svg-icons/faMegaphone';
import { faGraduationCap as falGraduationCap } from '@fortawesome/pro-light-svg-icons/faGraduationCap';
import { faChartLineUp as falChartLineUp } from '@fortawesome/pro-light-svg-icons/faChartLineUp';
import { faBookReader as falBookReader } from '@fortawesome/pro-light-svg-icons/faBookReader';
import { faCopy as falCopy } from '@fortawesome/pro-light-svg-icons/faCopy';

// Solid
import { faAlignRight as fasAlignRight } from '@fortawesome/pro-solid-svg-icons/faAlignRight';
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faTasks as fasTasks } from '@fortawesome/pro-solid-svg-icons/faTasks';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faArrowRight as fasArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faAward as fasAward } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faBan as fasBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBanSmoking as fasBanSmoking } from '@fortawesome/pro-solid-svg-icons/faBanSmoking';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBed as fasBed } from '@fortawesome/pro-solid-svg-icons/faBed';
import { faBookOpen as fasBookOpen } from '@fortawesome/pro-solid-svg-icons/faBookOpen';
import { faBookReader as fasBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBug as fasBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faBuilding as fasBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faCalendar as fasCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faChartLineUp as fasChartLineUp } from '@fortawesome/pro-solid-svg-icons/faChartLineUp';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCheckSquare as fasCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleExclamation as fasCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCity as fasCity } from '@fortawesome/pro-solid-svg-icons/faCity';
import { faClipboardCheck as fasClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCommentDots as fasCommentDots } from '@fortawesome/pro-solid-svg-icons/faCommentDots';
import { faClockRotateLeft as fasClockRotateLeft } from '@fortawesome/pro-solid-svg-icons/faClockRotateLeft';
import { faCopy as fasCopy } from '@fortawesome/pro-solid-svg-icons/faCopy';
import { faDice as fasDice } from '@fortawesome/pro-solid-svg-icons/faDice';
import { faDollarSign as fasDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faDumbbell as fasDumbbell } from '@fortawesome/pro-solid-svg-icons/faDumbbell';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faFileCertificate as fasFileCertificate } from '@fortawesome/pro-solid-svg-icons/faFileCertificate';
import { faExchangeAlt as fasExchangeAlt } from '@fortawesome/pro-solid-svg-icons/faExchangeAlt';
import { faFamily as fasFamily } from '@fortawesome/pro-solid-svg-icons/faFamily';
import { faFilePdf as fasFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFax as fasFax } from '@fortawesome/pro-solid-svg-icons/faFax';
import { faFish as fasFish } from '@fortawesome/pro-solid-svg-icons/faFish';
import { faGem as fasGem } from '@fortawesome/pro-solid-svg-icons/faGem';
import { faGlassMartini as fasGlassMartini } from '@fortawesome/pro-solid-svg-icons/faGlassMartini';
import { faGlobe as fasGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGolfBallTee as fasGolfBallTee } from '@fortawesome/pro-solid-svg-icons/faGolfBallTee';
import { faGraduationCap as fasGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as fasHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faHouseTree as fasHouseTree } from '@fortawesome/pro-solid-svg-icons/faHouseTree';
import { faInfo as fasInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faInfoCircle as fasInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faImage as fasImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faKey as fasKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLink as fasLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLongArrowLeft as fasLongArrowLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowLeft';
import { faMap as fasMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faMapMarker as fasMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faMapMarkerAlt as fasMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { faMaskSnorkel as fasMaskSnorkel } from '@fortawesome/pro-solid-svg-icons/faMaskSnorkel';
import { faMegaphone as fasMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faMicrowave as fasMicrowave } from '@fortawesome/pro-solid-svg-icons/faMicrowave';
import { faNewspaper as fasNewspaper } from '@fortawesome/pro-solid-svg-icons/faNewspaper';
import { faOven as fasOven } from '@fortawesome/pro-solid-svg-icons/faOven';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPaperPlane as fasPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faPlane as fasPlane } from '@fortawesome/pro-solid-svg-icons/faPlane';
import { faPlus as fasPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faPrint as fasPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faReceipt as fasReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faRoad as fasRoad } from '@fortawesome/pro-solid-svg-icons/faRoad';
import { faSailboat as fasSailboat } from '@fortawesome/pro-solid-svg-icons/faSailboat';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchPlus as fasSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShare as fasShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { faShieldAlt as fasShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faSignInAlt as fasSignInAlt } from '@fortawesome/pro-solid-svg-icons/faSignInAlt';
import { faSignOutAlt as fasSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faSpa as fasSpa } from '@fortawesome/pro-solid-svg-icons/faSpa';
import { faSparkles as fasSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStroopwafel as fasStroopwafel } from '@fortawesome/pro-solid-svg-icons/faStroopwafel';
import { faSwimmingPool as fasSwimmingPool } from '@fortawesome/pro-solid-svg-icons/faSwimmingPool';
import { faThList as fasThList } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTrash as fasTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTreasureChest as fasTreasureChest } from '@fortawesome/pro-solid-svg-icons/faTreasureChest';
import { faTrophy as fasTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { faTrophyStar as fasTrophyStar } from '@fortawesome/pro-solid-svg-icons/faTrophyStar';
import { faUmbrellaBeach as fasUmbrellaBeach } from '@fortawesome/pro-solid-svg-icons/faUmbrellaBeach';
import { faPlay as fasPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faUpload as fasUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUtensils as fasUtensils } from '@fortawesome/pro-solid-svg-icons/faUtensils';
import { faVideo as fasVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faVolumeHigh as fasVolumeHigh } from '@fortawesome/pro-solid-svg-icons/faVolumeHigh';
import { faWater as fasWater } from '@fortawesome/pro-solid-svg-icons/faWater';
import { faWheelchair as fasWheelchair } from '@fortawesome/pro-solid-svg-icons/faWheelchair';
import { faWindowClose as fasWindowClose } from '@fortawesome/pro-solid-svg-icons/faWindowClose';
import { faXmark as fasXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';

const exports = {
  fabAppStore,
  fabGooglePlay,
  fabFacebook,
  fabInstagram,
  fabLinkedin,
  fabPinterest,
  fabTumblr,
  fabTwitter,
  fabXTwitter,
  fabYelp,
  fabYoutube,
  fabBloggerB,
  fabTiktok,
  fabWeibo,
  farAt,
  farAward,
  farBadge,
  farBell,
  farBook,
  farBookReader,
  farCalendar,
  farCalendarAlt,
  farChartLineUp,
  farCheckCircle,
  farCircleDollar,
  farCircleExclamation,
  farClock,
  farCopy,
  farDollarSign,
  farDownload,
  farEnvelope,
  farExclamationTriangle,
  farCircleCheck,
  farFileCertificate,
  farFileXmark,
  farGraduationCap,
  farHandWave,
  farHandshake,
  farHeart,
  farList,
  farMegaphone,
  farMemoCircleCheck,
  farPrint,
  farSearch,
  farSearchPlus,
  farStroopwafel,
  farTriangleExclamation,
  farTrophy,
  farUser,
  falList,
  falHome,
  falMegaphone,
  falGraduationCap,
  falChartLineUp,
  falBookReader,
  falCopy,
  fasAlignRight,
  fasAngleLeft,
  fasTasks,
  fasAngleRight,
  fasArrowRight,
  fasAward,
  fasAt,
  fasBan,
  fasBanSmoking,
  fasBars,
  fasBed,
  fasBookOpen,
  fasBookReader,
  fasBug,
  fasBuilding,
  fasBullhorn,
  fasCalendar,
  fasCaretDown,
  fasCaretLeft,
  fasChartLine,
  fasChartLineUp,
  fasCheck,
  fasCheckCircle,
  fasCheckSquare,
  fasChevronDown,
  fasChevronLeft,
  fasChevronRight,
  fasCircle,
  fasCircleExclamation,
  fasCircleNotch,
  fasCity,
  fasClipboardCheck,
  fasClock,
  fasCommentDots,
  fasClockRotateLeft,
  fasCopy,
  fasDice,
  fasDollarSign,
  fasDownload,
  fasDumbbell,
  fasEnvelope,
  fasExclamationTriangle,
  fasFileCertificate,
  fasExchangeAlt,
  fasFamily,
  fasFilePdf,
  fasFax,
  fasFish,
  fasGem,
  fasGlassMartini,
  fasGlobe,
  fasGolfBallTee,
  fasGraduationCap,
  fasHandshake,
  fasHeart,
  fasHome,
  fasHouseTree,
  fasInfo,
  fasInfoCircle,
  fasImage,
  fasImages,
  fasKey,
  fasLink,
  fasList,
  fasLock,
  fasLongArrowLeft,
  fasMap,
  fasMapMarker,
  fasMapMarkerAlt,
  fasMaskSnorkel,
  fasMegaphone,
  fasMicrowave,
  fasNewspaper,
  fasOven,
  fasPhone,
  fasPaperPlane,
  fasPlane,
  fasPlus,
  fasPrint,
  fasReceipt,
  fasRoad,
  fasSailboat,
  fasSearch,
  fasSearchPlus,
  fasShare,
  fasShieldAlt,
  fasSignInAlt,
  fasSignOutAlt,
  fasSpa,
  fasSparkles,
  fasStar,
  fasStroopwafel,
  fasSwimmingPool,
  fasThList,
  fasTimes,
  fasTrash,
  fasTreasureChest,
  fasTrophy,
  fasTrophyStar,
  fasUmbrellaBeach,
  fasPlay,
  fasUpload,
  fasUser,
  fasUtensils,
  fasVideo,
  fasVolumeHigh,
  fasWater,
  fasWheelchair,
  fasWindowClose,
  fasXmark,
};

export default library.add(...Object.values(exports));

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
